var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "12px",
    viewBox: "0 0 43 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Limepay-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15.1-Payment-Modal-Validation",
    transform: "translate(-600.000000, -338.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(460.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards",
    transform: "translate(45.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4",
    fill: "#3399FF",
    points: "4.31660232 2.4 39.3142857 2.4 39.3142857 9.6 6.37528958 9.6 1.22857143 9.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6256536,9.28583558 L5.96068882,10.8 L0,10.8 L4.70408042,1.2 L15.9394482,1.2 L17.0734711,3.32015929 L18.1329651,1.2 L22.1241438,1.2 L24.1358622,1.2 L33.2805213,1.2 L34.575238,2.51793832 L35.9657674,1.2 L43,1.2 L38.0057662,5.98890598 L42.7844952,10.8 L35.9770431,10.8 L34.4540992,9.38597365 L32.9437574,10.8 L24.1358622,10.8 L22.1241438,10.8 L8.64454815,10.8 L7.91337585,9.28583558 L6.6256536,9.28583558 Z M7.91753418,9.38732366 L6.62143276,9.38732366 L7.91753418,9.38732366 Z M22.3157703,2.57141178 L19.3571332,2.57141178 L17.1312364,7.1656768 L14.7362036,2.57141178 L11.7776269,2.57141178 L11.7776269,9.22285274 L8.72052324,2.57141178 L5.94513189,2.57141178 L2.67674419,9.42858822 L4.67724779,9.42858822 L5.33943948,7.86511795 L9.14321148,7.86511795 L9.90405043,9.42858822 L13.5810167,9.42858822 L13.5810167,3.8467943 L16.1873329,9.42858822 L17.9061247,9.42858822 L20.4983916,3.94282355 L20.4983916,9.42858822 L22.3157703,9.42858822 L22.3157703,2.57141178 Z M34.5301347,4.79311793 L32.4169345,2.57141178 L23.935794,2.57141178 L23.935794,9.42858822 L32.1351024,9.42858822 L34.4596465,7.17941206 L36.7983008,9.42858822 L38.9819892,9.42858822 L35.6430534,5.95885301 L39.0805761,2.57141178 L36.7983008,2.57147056 L34.5301347,4.79311793 Z M30.064171,8.05711766 L25.7532331,8.05711766 L25.7532331,6.54858843 L30.064171,6.54858843 L30.064171,5.17711787 L25.7532331,5.17711787 L25.7532331,3.94282355 L30.064171,3.94282355 L30.064171,2.77708848 L33.2621304,5.89017671 L30.064171,9.01705898 L30.064171,8.05711766 Z M7.28362445,3.6958828 L8.52340935,6.47991213 L5.94513189,6.47991213 L7.28362445,3.6958828 Z",
    id: "path7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#FFFFFF",
    points: "14.7428571 1.2 17.2 3.6 19.6571429 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#FFFFFF",
    points: "4.91428571 9.6 7.37142857 12 8.6 8.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#FFFFFF",
    points: "31.9428571 9.6 34.4 12 35.6285714 8.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#FFFFFF",
    points: "31.9428571 1.2 34.4 3.6 35.6285714 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#FFFFFF",
    points: "36.8571429 5.2 39.3142857 8.4 40.5428571 3.6"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.da38185b.svg";
export { ForwardRef as ReactComponent };